import React from 'react'
import PropTypes from 'prop-types'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import { component as SpComponent } from '@cred/react-analytics/contexts'
import WidgetContext from 'components/widget-context'
import { EmptyList } from 'components/empty-list'
import { getLenderTileComponent, compareLendersRate } from './utils'
import styles from './styles.module.scss'

const getDarkenedBorderClassFromTheme = theme => (
    ['investopedia1', 'thebalance1'].includes(theme)
      ? styles.darkenedBorder
      : ''
  ),

  /* Sort lenders by minimum APR. */
  sortLenders = (lenders, compareFn) => lenders.sort(compareFn),

  renderLendersList = (sortedLenders, ctaUrl, noBorder, theme, name, className = '') => {
    const noBorderCssClass = noBorder ? styles.noBorder : '',
      darkenedBorderClass = getDarkenedBorderClassFromTheme(theme),
      isMultiVertical = name.includes('multiVertical'),
      LenderTile = getLenderTileComponent(name)

    return (
      <WidgetContext.Consumer>
        { value => (
          <div
            className={
              isMultiVertical
                ? `multivertical-lenders-list ${className}`
                : `${styles.lenders} ${darkenedBorderClass} ${noBorderCssClass} ${className}`
            }
          >
            {
              sortedLenders.map(lender => (
                <SnowplowContext contexts={[SpComponent.analytics({ name: lender.name })]} key={`lender-rate-${lender.slug}`}>
                  <LenderTile
                    tileName={name}
                    ctaUrl={ctaUrl}
                    key={`lender-rate-${lender.slug}`}
                    lender={lender}
                    widgetContext={value}
                    shouldDarkenBorder={!!darkenedBorderClass}
                  />
                </SnowplowContext>
              ))
            }
          </div>
        )}
      </WidgetContext.Consumer>
    )
  },

  LendersList = ({ resetFilters, lenders, ctaUrl, noBorder, theme, name, compareFn, className }) => {
    const sortedLenders = sortLenders(lenders, compareFn)

    return (
      sortedLenders.length === 0
        ? <EmptyList resetFilters={resetFilters} />
        : renderLendersList(sortedLenders, ctaUrl, noBorder, theme, name, className)
    )
  }

LendersList.propTypes = {
  name: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string,
  resetFilters: PropTypes.func,
  lenders: PropTypes.array,
  noBorder: PropTypes.bool,
  theme: PropTypes.string,
  compareFn: PropTypes.func,
  className: PropTypes.string,
}

LendersList.defaultProps = {
  ctaUrl: '',
  noBorder: false,
  resetFilters: () => {},
  compareFn: compareLendersRate,
}

export { LendersList, getDarkenedBorderClassFromTheme, sortLenders, compareLendersRate, renderLendersList }

export default LendersList
